import { Label } from "@ui/label"
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@ui/select"

import { CollectionItem } from "@vertesia/common"

interface ReportTypeSelectionProps {
    value: CollectionItem | undefined
    values: CollectionItem[]
    onChange: (value: CollectionItem | undefined) => void
}
export function ReportTypeSelection({ value, values, onChange }: Readonly<ReportTypeSelectionProps>) {
    const handleChange = (value: string) => {
        const selectedReport = values.find(report => report.name === value)
        onChange(selectedReport)
    }

    return (
        <div>
            <Label>Report Type</Label>
            <Select onValueChange={handleChange} value={value?.name}>
                <SelectTrigger className="text-start">
                    <SelectValue placeholder={"Select a Report type "} className="!whitespace-normal !text-clip-none text-left" />
                </SelectTrigger>
                <SelectContent className="max-h-[250px] w-[var(--radix-select-trigger-width)]">
                    <SelectGroup>
                        {
                            values.map((report, index) => (
                                <SelectItem key={index} value={report.name} className="flex-col items-start">
                                    <span className="font-medium">{report.name}</span>
                                    <div className="text-sm text-muted-foreground whitespace-normal break-words w-full">
                                        {(report as any)?.properties?.description || "No description available"}
                                    </div>
                                </SelectItem>
                            ))
                        }
                    </SelectGroup>
                </SelectContent>
            </Select>
        </div>
    )
}